import React, { useEffect, useState } from "react";

import Navbar from "../../../components/Navbar.js";

import From from "./PAForm.js";

import {
  Card,
  Typography,
  Button,
  CardHeader,
  CardBody,
} from "@material-tailwind/react";

const navbar = document.getElementById("navbar");

navbar?.classList.add("is-sticky");

//  Function to filter photos array based on tag

export default function PartnershipAssessment() {
  const [isMobile, setIsMobile] = useState(false);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Add event listener to handle window resize
    window.addEventListener("resize", handleResize);

    // Initial check on component mount
    handleResize();

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleStartClick = () => {
    setShowForm(true);
  };

  return (
    <>
      <Navbar />

      <section
        className="
        relative pt-25 overflow-hidden flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('/images/slider/1.png')",
          height: "100vh",
        }}
        id="self-test"
      >
        <div className=" container-self-test  px-4 ">
          <div className="flex justify-center items-center ">
            <div className="">
              {/* ======================================= */}
              <Card
                shadow={false}
                className=" overflow-hidden border border-gray-300 p-6 bg-white rounded-lg self-test-card"
              >
                <CardHeader
                  shadow={false}
                  className="text-center self-test-cardHeader"
                >
                  <Typography
                    variant="h1"
                    color="blue-gray"
                    className="text-2xl md:text-3xl font-bold"
                  >
                    伴侶關係評估
                  </Typography>
                </CardHeader>

                <CardBody>
                  {!showForm ? (
                    <form action="#" className="flex flex-col gap-4  md:mt-12">
                      <Typography className="text-gray-600 text-base md:text-lg font-light self-test-content">
                        請根據您與配偶相處的情況，以最短時間直覺回應問題，選出最符合您的真實狀況。
                      </Typography>
                      <div className="flex justify-center">
                        <Button
                          size="lg"
                          className="flex h-12 border-blue-gray-200 items-center justify-center gap-2 font-reborn bg-black text-white rounded-lg self-test-button"
                          onClick={handleStartClick}
                          variant="filled"
                        >
                          <Typography
                            variant="h6"
                            className="text-left mx-auto font-bold text-gray-600 w-[95vw]"
                          >
                            開始
                          </Typography>
                        </Button>
                      </div>
                    </form>
                  ) : (
                    <From />
                  )}
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
